import api from '../../../api/client';
// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Row, Col, Card, Table, Button } from "react-bootstrap";
// // import { Link, useNavigate } from 'react-router-dom';
// import config from "./../../../config";
// import axios from "axios";
// import ModuleNotification from "../../../components/Widgets/Statistic/Notification";
// import AmChartEarnings from "./chart/AmChartEarnings";
// import AmChartStatistics6 from "./chart/AmChartStatistics6";
// import BarDiscreteChart from "../../../views/charts/nvd3-chart/chart/BarDiscreteChart.js";
// import MultiBarChart from "../../../views/charts/nvd3-chart/chart/MultiBarChart.js";
// import { Link } from "react-router-dom";
// import StockDiffDashboard from "./FarmAdvisoryWidget.js";
// import ThresholdSettings from "../../extra/SamplePage12021.js";
// import StockAlertsDashboard from "../../extra/StockAlertsDashboard.js";
// import MainCard from "../../../components/Card/MainCard.js";
// import FarmAdvisoryWidget from "./FarmAdvisoryWidget.js";
// import FinancialSummaryWidget from "./FinancialSummary.js";
// import { usePermissions } from "../../../permissions/index.js";
// // import StockStatusDisplay from "../../extra/StockAlertsDashboard.js";
// import WeatherDisplay from "../../../components/WeatherDisplay";

// const DashDefault = () => {
//   const account = useSelector((state) => state.account);
//   const [data, setData] = useState({});
//   const [totalQuantity, setTotalQuantity] = useState(0);
//   const [totalEggsSold, setTotalEggsSold] = useState(0);
//   const [totalEggsCollected, setTotalEggsCollected] = useState(0);
//   const [totalTraysCollected, setTotalTraysCollected] = useState(0);
//   const [totalBirdsSold, setTotalBirdsSold] = useState(0);
//   const [totalSpoilt, setTotalSpoilt] = useState(0);
//   const [totalDead, setTotalDead] = useState(0);
//   const [totalpigsSired, setPigsSired] = useState(0);
//   const [totalFeedQuantity, setTotalFeedQuantity] = useState(0);
//   const [totalPoultry, setTotalPoultry] = useState(0);
//   const [totalCapacity, setTotalCapacity] = useState(0);
//   const [totalRefill, setTotalRefill] = useState(0);
//   const [totalUsers, setTotalUsers] = useState(0);
//   const [totalAdmins, setTotalAdmins] = useState(0);
//   const [totalPigs, setTotalPigs] = useState(0);
//   const [totalpigsSold, setTotalPigsSold] = useState(0);
//   const [totalGoatsSold, setTotalGoatsSold] = useState(0);
//   const [totalPigsDead, setTotalPigsDead] = useState(0);
//   const [totalGoats, setTotalGoats] = useState(0);
//   const [totalSheep, setTotalSheep] = useState(0);
//   const [totalGoatsDead, setTotalGoatsDead] = useState(0);
//   const [totalSired, setTotalGoatsSired] = useState(0);
//   const [earnings, setEarnings] = useState({ totalEarnings: 0 });
//   const [dead, setDead] = useState({ totalDead: 0 });
//   const [water, setWater] = useState({ totalWater: 0 });
//   const [feed, setFeed] = useState({ totalFeed: 0 });
//   const [expenses, setExpenses] = useState({ totalExpenses: 0 });
//   const [goatExpenses, setGoatExpenses] = useState({ totalGoatExpenses: 0 });
//   const [pigsExpenses, setPigsExpenses] = useState({ totalPigsExpenses: 0 });
//   const [salary, setSalary] = useState({ totalSalary: 0 });
//   const [poultryExpenses, setPoultryExpenses] = useState({
//     totalPoultryExpenses: 0,
//   });
//   const [feedExpenses, setFeedExpenses] = useState({ totalFeedExpenses: 0 });
//   const [feedRestock, setFeedRestock] = useState({ totalFeedRestock: 0 });
//   const [waterRefill, setWaterRefill] = useState({ totalWaterRefill: 0 });
//   const [waterConsumption, setWaterConsumption] = useState({
//     totalWaterConsumption: 0,
//   });
//   const { createPermission, deletePermission, editPermission } =
//     usePermissions();
//   const environment =
//     window.location.hostname === "localhost" ? "development" : "production";
//   const apiUrl = config[environment].apiUrl;
//   const space = account.user.is_admin;
//   const [userRoles, setUserRoles] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const logedRole = userRoles.find((o) => o.value === space)?.label;
//   const isAdmin = logedRole && logedRole.toLowerCase().includes("admin");

//   useEffect(() => {
//     const fetchUserRoles = async () => {
//       try {
//         const response = await api.get(`/roles`);
//         const rolesData = response.data;
//         const options = rolesData.map((role) => ({
//           value: role.id,
//           label: role.name,
//         }));
//         setUserRoles(options);
//       } catch (error) {
//         console.log(error);
//       } finally {
//         setLoading(false); // ✅ Done loading whether success or error
//       }
//     };

//     fetchUserRoles();
//   }, [account, apiUrl]);

//   useEffect(() => {
//     fetch(`/earnings`)
//       .then((response) => response.json())
//       .then((data) => setEarnings(data))
//       .catch((error) => console.error("Error:", error));
//   }, []);

//   //   useEffect(() => {
//   //     fetch(`/water/consumption`)
//   //       .then((response) => response.json())
//   //       .then((data) => setWaterConsumption(data))
//   //       .catch((error) => console.error('Error:', error));
//   //   }, []);

//   //   useEffect(() => {
//   //     fetch(`/pigs/expenses`)
//   //       .then((response) => response.json())
//   //       .then((data) => setPigsExpenses(data))
//   //       .catch((error) => console.error('Error:', error));
//   //   }, []);

//   //   useEffect(() => {
//   //     fetch(`/water/expenses`)
//   //       .then((response) => response.json())
//   //       .then((data) => setWaterRefill(data))
//   //       .catch((error) => console.error('Error:', error));
//   //   }, []);

//   //   useEffect(() => {
//   //     fetch(`/restock/expenses`)
//   //       .then((response) => response.json())
//   //       .then((data) => setFeedRestock(data))
//   //       .catch((error) => console.error('Error:', error));
//   //   }, []);

//   //   useEffect(() => {
//   //     fetch(`/feeds/expenses`)
//   //       .then((response) => response.json())
//   //       .then((data) => setFeedExpenses(data))
//   //       .catch((error) => console.error('Error:', error));
//   //   }, []);

//   //   useEffect(() => {
//   //     fetch(`/poultry/expenses`)
//   //       .then((response) => response.json())
//   //       .then((data) => setPoultryExpenses(data))
//   //       .catch((error) => console.error('Error:', error));
//   //   }, []);

//   useEffect(() => {
//     fetch(`/expenses`)
//       .then((response) => response.json())
//       .then((expenses) => setExpenses(expenses))
//       .catch((error) => console.error("Error:", error));
//   }, []);

//   //   useEffect(() => {
//   //     fetch(`/goat/expenses`)
//   //       .then((response) => response.json())
//   //       .then((goatExpenses) => setGoatExpenses(goatExpenses))
//   //       .catch((error) => console.error('Error:', error));
//   //   }, []);

//   useEffect(() => {
//     fetch(`/users/salary`)
//       .then((response) => response.json())
//       .then((salary) => setSalary(salary))
//       .catch((error) => console.error("Error:", error));
//   }, [apiUrl]);

//   //   useEffect(() => {
//   //     fetch(`/waterConsumption`)
//   //       .then((response) => response.json())
//   //       .then((data) => setWater(data))
//   //       .catch((error) => console.error('Error:', error));
//   //   }, []);

//   useEffect(() => {
//     fetch(`/feedConsumption`)
//       .then((response) => response.json())
//       .then((data) => setFeed(data))
//       .catch((error) => console.error("Error:", error));
//   }, [apiUrl]);

//   //   useEffect(() => {
//   //     fetch(`/dead`)
//   //       .then((response) => response.json())
//   //       .then((data) => setDead(data))
//   //       .catch((error) => console.error('Error:', error));
//   //   }, []);

//   useEffect(() => {
//     axios
//       .get(`/poultry/total`)
//       .then((response) => {
//         setTotalPoultry(response.data.totalQuantity);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);

//   useEffect(() => {
//     axios
//       .get(`/water/total`)
//       .then((response) => {
//         setTotalCapacity(response.data.totalCapacity);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);

//   useEffect(() => {
//     axios
//       .get(`/feeds/total`)
//       .then((response) => {
//         setTotalFeedQuantity(response.data.totalFeedQuantity);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);
//   useEffect(() => {
//     axios
//       .get(`/water/refill`)
//       .then((response) => {
//         setTotalRefill(response.data.totalRefill);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);

//   useEffect(() => {
//     axios
//       .get(`/goats/total`)
//       .then((response) => {
//         setTotalGoats(response.data.totalGoats);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);

//   useEffect(() => {
//     axios
//       .get(`/sheep/total`)
//       .then((response) => {
//         setTotalSheep(response.data.totalSheep);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);

//   useEffect(() => {
//     axios
//       .get(`/total/pigs`)
//       .then((response) => {
//         setTotalPigs(response.data.totalPigs);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);

//   useEffect(() => {
//     axios
//       .get(`/users/total`)
//       .then((response) => {
//         setTotalUsers(response.data.totalUsers);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);

//   useEffect(() => {
//     axios
//       .get(`/admins/total`)
//       .then((response) => {
//         setTotalAdmins(response.data.totalAdmins);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);

//   useEffect(() => {
//     axios
//       .get(`/poultry/total`)
//       .then((response) => {
//         setTotalQuantity(response.data.totalQuantity);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);

//   useEffect(() => {
//     axios
//       .get(`/eggsSold/total`)
//       .then((response) => {
//         setTotalEggsSold(response.data.totalEggsSold);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);

//   useEffect(() => {
//     axios
//       .get(`/eggsCollected/total`)
//       .then((response) => {
//         setTotalEggsCollected(response.data.totalCollected);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);

//   useEffect(() => {
//     axios
//       .get(`/traysCollected/total`)
//       .then((response) => {
//         setTotalTraysCollected(response.data.totalTrays);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);

//   useEffect(() => {
//     axios
//       .get(`/totalBirdsSold`)
//       .then((response) => {
//         setTotalBirdsSold(response.data.totalBirdsSold);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);
//   useEffect(() => {
//     axios
//       .get(`/goatsSold/total`)
//       .then((response) => {
//         setTotalGoatsSold(response.data.totalGoatsSold);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);
//   useEffect(() => {
//     axios
//       .get(`/totalGoatsDead`)
//       .then((response) => {
//         setTotalGoatsDead(response.data.totalGoatsDead);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);
//   useEffect(() => {
//     axios
//       .get(`/goatsSired/total`)
//       .then((response) => {
//         setTotalGoatsSired(response.data.totalSired);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);

//   useEffect(() => {
//     axios
//       .get(`/pigsSold/total`)
//       .then((response) => {
//         setTotalPigsSold(response.data.totalpigsSold);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);
//   useEffect(() => {
//     axios
//       .get(`/pigsDead/total`)
//       .then((response) => {
//         setTotalPigsDead(response.data.totalPigsDead);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);

//   useEffect(() => {
//     axios
//       .get(`/eggsBroken/total`)
//       .then((response) => {
//         setTotalSpoilt(response.data.totalSpoilt);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);
//   useEffect(() => {
//     axios
//       .get(`/dead/total`)
//       .then((response) => {
//         setTotalDead(response.data.totalDead);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);
//   useEffect(() => {
//     axios
//       .get(`/pigsSired/total`)
//       .then((response) => {
//         setPigsSired(response.data.totalpigsSired);
//         // console.log(response);
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   }, [apiUrl]);

//   // Each tray holds 30 eggs
//   const EGGS_PER_TRAY = 30;

//   // Convert collected eggs into trays and get remaining eggs
//   const traysRem = Math.floor(totalEggsCollected / EGGS_PER_TRAY);

//   return (
//     <React.Fragment>
//       <Row>
//         <Col md={6} xl={3} xs={6}>
//           <Link to="/poultry/poultry">
//             <Card style={{}}>
//               <Card.Body className="">
//                 <h6 className="mb-4 ">Poultry</h6>
//                 <div className="row d-flex align-items-center">
//                   <div className="col-9">
//                     {totalPoultry && (
//                       <h5 className="f-w-300 d-flex align-items-center m-b-0 ">
//                         {/* <i className="feather icon-arrow-up text-c-green f-30 m-r-5" />  */}
//                         {totalPoultry?.toLocaleString()}
//                       </h5>
//                     )}
//                   </div>

//                   <div className="col-3 text-right">
//                     {/* <i class="fa fa-leaf f-20 text-c-grey m-r-5" aria-hidden="true"></i> */}
//                     <img
//                       src="/assets/cock.png"
//                       alt="Chicken"
//                       style={{ minWidth: "10px", maxWidth: "30px" }}
//                     />
//                   </div>
//                 </div>
//                 <div
//                   className="progress m-t-30"
//                   style={{ height: "7px" }}
//                 ></div>
//               </Card.Body>
//             </Card>
//           </Link>
//         </Col>

//         <Col md={6} xl={3} xs={6}>
//           <Link to="/pigs/pigs">
//             <Card style={{}}>
//               <Card.Body className="">
//                 <h6 className="mb-4 ">Pigs</h6>
//                 <div className="row d-flex align-items-center">
//                   <div className="col-9">
//                     {totalPigs && (
//                       <h5 className="f-w-300 d-flex align-items-center m-b-0 ">
//                         {/* <i className="feather icon-arrow-down text-c-red f-30 m-r-5" />  */}
//                         {totalPigs?.toLocaleString()}
//                       </h5>
//                     )}
//                   </div>
//                   <div className="col-3 text-right">
//                     {/* <i class="fa fa-bug f-20 text-c-grey m-r-5" aria-hidden="true"></i> */}
//                     <img
//                       src="/assets/pig (1).png"
//                       alt="Chicken"
//                       style={{ minWidth: "10px", maxWidth: "30px" }}
//                     />
//                   </div>
//                 </div>
//                 <div className="progress m-t-30" style={{ height: "7px" }}>
//                   {/* <div
//                             className="progress-bar"
//                             role="progressbar"
//                             style={{ minWidth: "10px", maxWidth: `${progressminWidth: "10px", maxWidth}%`, backgroundColor: progressBarColor }}
//                             aria-valuenow={progressminWidth: "10px", maxWidth}
//                             aria-valuemin="0"
//                             aria-valuemax="100"
//                         /> */}

//                   {/* <div
//                                     className="progress-bar progress-c-theme"
//                                     role="progressbar"
//                                     style={{ minWidth: "10px", maxWidth: '70%' }}
//                                     aria-valuenow="70"
//                                     aria-valuemin="0"
//                                     aria-valuemax="100"
//                                 /> */}
//                 </div>
//               </Card.Body>
//             </Card>
//           </Link>
//         </Col>
//         <Col md={6} xl={3} xs={6}>
//           <Link to="/goats/goats">
//             <Card style={{}}>
//               <Card.Body className="">
//                 <h6 className="mb-4 ">Goats</h6>
//                 <div className="row d-flex align-items-center">
//                   <div className="col-9">
//                     {totalGoats && (
//                       <h5 className="f-w-300 d-flex align-items-center m-b-0 ">
//                         {/* <i className="feather icon-arrow-up text-c-green f-30 m-r-5" />  */}
//                         {totalGoats?.toLocaleString()}
//                       </h5>
//                     )}
//                   </div>

//                   <div className="col-3 text-right">
//                     {/* <i class="fa fa-tags f-20 text-c-grey m-r-5" aria-hidden="true"></i> */}
//                     <img
//                       src="/assets/goat (1).png"
//                       alt="Chicken"
//                       style={{ minWidth: "10px", maxWidth: "30px" }}
//                     />
//                   </div>
//                 </div>
//                 <div className="progress m-t-30" style={{ height: "7px" }}>
//                   {/* <div
//                                     className="progress-bar progress-c-theme"
//                                     role="progressbar"
//                                     style={{ minWidth: "10px", maxWidth: '70%' }}
//                                     aria-valuenow="70"
//                                     aria-valuemin="0"
//                                     aria-valuemax="100"
//                                 /> */}
//                 </div>
//               </Card.Body>
//             </Card>
//           </Link>
//         </Col>
//         <Col md={6} xl={3} xs={6}>
//           {/* {space !== "User" ? ( */}

//           {/* <Link to="/users/employees"> */}
//           <Link to="/sheep/sheep">
//             <Card style={{}}>
//               <Card.Body className="">
//                 <h6 className="mb-4">Sheep</h6>
//                 <div className="row d-flex align-items-center">
//                   <div className="col-9">
//                     {totalSheep && (
//                       <h5 className="f-w-300 d-flex align-items-center m-b-0">
//                         {totalSheep?.toLocaleString()}
//                       </h5>
//                     )}
//                   </div>
//                   <div className="col-3 text-right">
//                     {/* <i class="fa fa-users f-20 text-c-grey m-r-5" aria-hidden="true"></i> */}
//                     <img
//                       src="/assets/sheep1.png"
//                       alt="Chicken"
//                       style={{ minWidth: "10px", maxWidth: "30px" }}
//                     />
//                   </div>
//                 </div>
//                 <div
//                   className="progress m-t-30"
//                   style={{ height: "7px" }}
//                 ></div>
//               </Card.Body>
//             </Card>
//           </Link>
//         </Col>

//         <Col lg={12}>
//           <Row className="g-4">
//             {/* <Col md={4} xs={12}>
//               <MainCard title="Financial Summary" isOption>
//                 <FarmAdvisoryWidget />
//               </MainCard>
//             </Col>
//             <Col md={4} xs={12}>
//               <FinancialSummaryWidget />
//             </Col> */}
//             {createPermission ? (
//               <>
//                 <Col md={8} lg={8} xs={12}>
//                   <StockAlertsDashboard />
//                 </Col>
//                 <Col md={4} lg={4} xs={12}>
//                   <WeatherDisplay />
//                 </Col>
//               </>
//             ) : null}
//           </Row>
//         </Col>

//         <Col md={12} xl={12} sm={12}>
//           <Card>
//             <Card.Header>
//               <Card.Title as="h5">Animal Management</Card.Title>
//             </Card.Header>
//             <Card.Body style={{ padding: "0 25px" }}>
//               <Row>
//                 {/* Poultry */}
//                 <Col sm={12} md={3} xs={6}>
//                   <p className="m-t-10">Poultry</p>
//                   {apiUrl && (
//                     <ModuleNotification
//                       message={"Total Birds"}
//                       className="feather icon-trending-up"
//                       count={totalQuantity.toLocaleString()}
//                     />
//                   )}
//                   {apiUrl && (
//                     <ModuleNotification
//                       message="Birds Sold"
//                       count={totalBirdsSold.toLocaleString()}
//                     />
//                   )}
//                   {apiUrl && (
//                     <ModuleNotification
//                       message="Birds Mortality"
//                       count={totalDead.toLocaleString()}
//                     />
//                   )}
//                 </Col>

//                 {/* Pigs */}
//                 <Col sm={12} md={3} xs={6}>
//                   <p className="m-t-10">
//                     {/* Total Eggs - {totalEggsCollected.toLocaleString()} */}
//                     Eggs
//                   </p>
//                   {apiUrl && (
//                     <ModuleNotification
//                       message="Trays Available"
//                       count={traysRem?.toLocaleString()}
//                     />
//                   )}
//                   {apiUrl && (
//                     <ModuleNotification
//                       message="Trays Sold"
//                       count={totalEggsSold.toLocaleString()}
//                     />
//                   )}
//                   {apiUrl && (
//                     <ModuleNotification
//                       message={"Broken Eggs"}
//                       className="feather icon-trending-up"
//                       count={totalSpoilt.toLocaleString()}
//                     />
//                   )}
//                 </Col>

//                 {/* Goats */}
//                 <Col sm={12} md={3} xs={6}>
//                   <p className="m-t-10">Goats</p>
//                   {apiUrl && (
//                     <ModuleNotification
//                       message="Goats Sold"
//                       count={totalGoatsSold.toLocaleString()}
//                     />
//                   )}
//                   {apiUrl && (
//                     <ModuleNotification
//                       message="Kids Sired"
//                       count={totalSired.toLocaleString()}
//                     />
//                   )}
//                   {apiUrl && (
//                     <ModuleNotification
//                       message={"Goats Mortality"}
//                       className="feather icon-trending-up"
//                       count={totalGoatsDead.toLocaleString()}
//                     />
//                   )}
//                 </Col>

//                 {/* Something els */}
//                 <Col sm={12} md={3} xs={6}>
//                   <p className="m-t-10">Pigs</p>
//                   {apiUrl && (
//                     <ModuleNotification
//                       message="Pigs Sold"
//                       count={totalpigsSold.toLocaleString()}
//                     />
//                   )}
//                   {apiUrl && (
//                     <ModuleNotification
//                       message="Piglets Sired"
//                       count={totalpigsSired.toLocaleString()}
//                     />
//                   )}
//                   {apiUrl && (
//                     <ModuleNotification
//                       message="Pigs Mortality"
//                       count={totalPigsDead.toLocaleString()}
//                     />
//                   )}
//                 </Col>
//               </Row>
//             </Card.Body>
//           </Card>
//         </Col>

//         <Col md={6} xl={3} sm={12}>
//           <Card>
//             <Card.Header>
//               <Card.Title as="h5">Tentative Profit & Loss</Card.Title>
//             </Card.Header>
//             <Row>
//               {createPermission ? (
//                 <Col md={12} sm={12}>
//                   <Link to="/earnings">
//                     <Card.Body className="border-bottom">
//                       <div className="row d-flex align-items-center">
//                         <div className="col-2">
//                           {" "}
//                           <img
//                             src="/assets/income.png"
//                             alt="Earnings"
//                             style={{ width: "30px" }}
//                           />
//                         </div>

//                         <div className="col-10 mt-2">
//                           <span className="d-block text-uppercase">
//                             Total Earnings
//                           </span>
//                           {/* <i className="feather icon-trending-up text-c-green f-30 m-r-5" />  */}
//                           {earnings && (
//                             <h5 className="">
//                               Ksh.{" "}
//                               {earnings.totalEarnings !== null
//                                 ? earnings.totalEarnings.toLocaleString(
//                                     undefined,
//                                     {
//                                       minimumFractionDigits: 2,
//                                       maximumFractionDigits: 2,
//                                     },
//                                   )
//                                 : ""}
//                             </h5>
//                           )}
//                         </div>
//                       </div>
//                     </Card.Body>
//                   </Link>
//                 </Col>
//               ) : (
//                 <Col md={12} sm={12}>
//                   <Card.Body className="border-bottom">
//                     <div className="row d-flex align-items-center">
//                       <div className="col-2">
//                         {" "}
//                         <img
//                           src="/assets/income.png"
//                           alt="Earnings"
//                           style={{ width: "30px" }}
//                         />
//                       </div>

//                       <div className="col-10 mt-2">
//                         <span className="d-block text-uppercase">
//                           Total Earnings
//                         </span>
//                         {/* <i className="feather icon-trending-up text-c-green f-30 m-r-5" />  */}
//                         {earnings && <h5 className="">Ksh. 0.00</h5>}
//                       </div>
//                     </div>
//                   </Card.Body>
//                 </Col>
//               )}
//               {createPermission ? (
//                 <Col md={12} sm={12}>
//                   <Link to="/expenditure">
//                     <Card.Body className="border-bottom">
//                       <div className="row d-flex align-items-center">
//                         <div className="col-2">
//                           <img
//                             src="/assets/expenses.png"
//                             alt="Expense"
//                             style={{ width: "30px" }}
//                           />
//                         </div>
//                         <div className="col-10 mt-2">
//                           <span className="d-block text-uppercase">
//                             Total Expenditure
//                           </span>
//                           {/* <i className="feather icon-trending-down text-c-green f-30 m-r-5" />  */}
//                           {expenses && (
//                             <h5 className="">
//                               Ksh.{" "}
//                               {expenses.totalExpenses !== null
//                                 ? expenses.totalExpenses.toLocaleString(
//                                     undefined,
//                                     {
//                                       minimumFractionDigits: 2,
//                                       maximumFractionDigits: 2,
//                                     },
//                                   )
//                                 : ""}
//                             </h5>
//                           )}
//                         </div>
//                       </div>
//                     </Card.Body>
//                   </Link>
//                 </Col>
//               ) : (
//                 <Col md={12} sm={12}>
//                   <Card.Body className="border-bottom">
//                     <div className="row d-flex align-items-center">
//                       <div className="col-2">
//                         <img
//                           src="/assets/expenses.png"
//                           alt="Expense"
//                           style={{ width: "30px" }}
//                         />
//                       </div>
//                       <div className="col-10 mt-2">
//                         <span className="d-block text-uppercase">
//                           Total Expenditure
//                         </span>
//                         {/* <i className="feather icon-trending-down text-c-green f-30 m-r-5" />  */}
//                         {expenses && <h5 className="">Ksh. 0.00</h5>}
//                       </div>
//                     </div>
//                   </Card.Body>
//                 </Col>
//               )}
//             </Row>
//           </Card>
//         </Col>
//         {/* ) : null} */}

//         <Col md={6} xl={3} sm={12}>
//           <Card>
//             <Card.Header>
//               <Card.Title as="h5">Water</Card.Title>
//             </Card.Header>
//             <Link to="/water">
//               <Card.Body className="border-bottom">
//                 <div className="row d-flex align-items-center">
//                   <div className="col-2">
//                     <img
//                       src="/assets/water.png"
//                       alt="water"
//                       style={{ width: "30px" }}
//                     />
//                   </div>
//                   <div className="col-10 mt-2">
//                     <span className="d-block text-uppercase">
//                       available water
//                     </span>

//                     <h5>
//                       {totalCapacity && (
//                         <h5>{totalCapacity.toLocaleString()} Litres</h5>
//                       )}
//                     </h5>
//                   </div>
//                 </div>
//               </Card.Body>
//             </Link>
//             <Link to="/water/water-refill">
//               <Card.Body className="border-bottom">
//                 <div className="row d-flex align-items-center">
//                   <div className="col-2">
//                     <img
//                       src="/assets/water.png"
//                       alt="water"
//                       style={{ width: "30px" }}
//                     />
//                   </div>
//                   <div className="col-10 mt-2">
//                     <span className="d-block text-uppercase">
//                       water refilled
//                     </span>
//                     <h5>
//                       {totalRefill && (
//                         <h5>{totalRefill.toLocaleString()} Litres</h5>
//                       )}
//                     </h5>
//                   </div>
//                 </div>
//               </Card.Body>
//             </Link>
//           </Card>
//         </Col>

//         <Col md={6} xl={3} sm={12}>
//           <Card>
//             <Card.Header>
//               <Card.Title as="h5">Feeds</Card.Title>
//             </Card.Header>
//             <Link to="/feeds">
//               <Card.Body className="border-bottom">
//                 <div className="row d-flex align-items-center">
//                   <div className="col-2">
//                     <img
//                       src="/assets/feed.png"
//                       alt="Chicken"
//                       style={{ width: "30px" }}
//                     />
//                   </div>
//                   <div className="col-10 mt-2">
//                     <span className="d-block text-uppercase">
//                       available feeds
//                     </span>

//                     {totalFeedQuantity && (
//                       <h5>{totalFeedQuantity.toLocaleString()} Kgs</h5>
//                     )}
//                   </div>
//                 </div>
//               </Card.Body>
//             </Link>
//             <Link to="/feeds/consumed-feeds">
//               <Card.Body className="border-bottom">
//                 <div className="row d-flex align-items-center">
//                   <div className="col-2">
//                     <img
//                       src="/assets/feed.png"
//                       alt="Chicken"
//                       style={{ width: "30px" }}
//                     />
//                   </div>
//                   <div className="col-10 mt-2">
//                     <span className="d-block text-uppercase">
//                       Feeds consumed
//                     </span>
//                     <h5>{feed.totalFeed.toLocaleString()} Kgs</h5>
//                   </div>
//                 </div>
//               </Card.Body>
//             </Link>
//           </Card>
//         </Col>
//         {isAdmin ? (
//           <Col md={6} xl={3} sm={12}>
//             <Card>
//               <Card.Header>
//                 <Card.Title as="h5">Users</Card.Title>
//               </Card.Header>
//               <Link to="/users/employees">
//                 <Card.Body className="border-bottom">
//                   <div className="row d-flex align-items-center">
//                     <div className="col-2">
//                       <img
//                         src="/assets/group.png"
//                         alt="Chicken"
//                         style={{ width: "30px" }}
//                       />
//                     </div>
//                     <div className="col-10 mt-2">
//                       <span className="d-block text-uppercase">Employees</span>

//                       {totalUsers && <h5>{totalUsers.toLocaleString()}</h5>}
//                     </div>
//                   </div>
//                 </Card.Body>
//               </Link>
//               <Link to="/users/admins">
//                 <Card.Body className="border-bottom">
//                   <div className="row d-flex align-items-center">
//                     <div className="col-2">
//                       <img
//                         src="/assets/group.png"
//                         alt="Chicken"
//                         style={{ width: "30px" }}
//                       />
//                     </div>
//                     <div className="col-10 mt-2">
//                       <span className="d-block text-uppercase">Admins</span>
//                       {totalAdmins && <h5>{totalAdmins.toLocaleString()}</h5>}
//                     </div>
//                   </div>
//                 </Card.Body>
//               </Link>
//             </Card>
//           </Col>
//         ) : null}

//         <Col md={6} xl={6} sm={12}>
//           <Card>
//             <Card.Header>
//               <Card.Title as="h5">Stock</Card.Title>
//             </Card.Header>
//             <Card.Body className="border-bottom">
//               <MultiBarChart />
//             </Card.Body>
//           </Card>
//         </Col>

//         <Col md={6} xl={6} sm={12}>
//           <Card>
//             <Card.Header>
//               <Card.Title as="h5">Sales</Card.Title>
//             </Card.Header>
//             <Card.Body className="border-bottom">
//               <BarDiscreteChart />
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>
//     </React.Fragment>
//   );
// };

// export default DashDefault;

import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Statistic,
  Table,
  Progress,
  Spin,
  Tabs,
  DatePicker,
  Select,
  Button,
  Space,
  Tag,
  Badge,
  Tooltip,
  Modal,
  Descriptions,
  Divider,
  List,
  Avatar,
  Alert,
  message,
} from "antd";
import {
  ShoppingOutlined,
  DollarOutlined,
  DatabaseOutlined,
  TeamOutlined,
  RiseOutlined,
  FallOutlined,
  CarOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  WarningOutlined,
  ReloadOutlined,
  DownloadOutlined,
  FilterOutlined,
  EyeOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  FileAddFilled,
  MoneyCollectOutlined,
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import { Line, Bar, Pie, Area } from "@ant-design/charts";
import config from "../../../config";
import { useSelector } from "react-redux";
import { usePermissions } from "../../../permissions";
import AnimalAssetsDashboard from "../AnimalAssetsDashboard";
import { formatKES } from "../../../utils/currency";

const { RangePicker } = DatePicker;
const { Option } = Select;
const { TabPane } = Tabs;

function Dashboard() {
  const account = useSelector((state) => state.account);
  const user = account?.user;
  const [loading, setLoading] = useState(true);
  const [dateRange, setDateRange] = useState([
    dayjs().startOf("month"),
    dayjs(),
  ]);
  const [selectedFarm, setSelectedFarm] = useState("all");
  const [stats, setStats] = useState({});
  const [assetsData, setAssetsData] = useState({ data: [], summary: {} });
  const [salesData, setSalesData] = useState({ sales: [], summary: {} });
  const [consumptionsData, setConsumptionsData] = useState({
    data: [],
    summary: {},
  });
  const [inventoryData, setInventoryData] = useState({
    headers: [],
    items: [],
    summary: {},
  });
  const [hrData, setHrData] = useState({ employees: [], summary: {} });
  const [accountingData, setAccountingData] = useState({
    transactions: [],
    summary: {},
  });
  const [chartData, setChartData] = useState({});
  const [recentActivities, setRecentActivities] = useState([]);
  const [activeTab, setActiveTab] = useState("overview");
  const [activeTabs, setActiveTabs] = useState("analytics");
  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;
  const { createPermission, deletePermission, editPermission } =
    usePermissions();
  const [userRoles, setUserRoles] = useState([]);

  const [farms, setFarms] = useState([]);

  useEffect(() => {
    fetchFarms();
  }, [apiUrl]);

  const fetchFarms = async () => {
    try {
      const response = await api.get(`/farm`);

      // adjust depending on your API response structure
      setFarms(response.data || []);
    } catch (error) {
      console.error("Failed to fetch farms", error);
    }
  };

  useEffect(() => {
    const fetchUserRoles = async () => {
      try {
        const response = await api.get(`/roles`);
        const rolesData = response.data;
        const options = rolesData.map((role) => ({
          value: role.id,
          label: role.name,
        }));
        setUserRoles(options);
      } catch (error) {
} finally {
        setLoading(false); // ✅ Done loading whether success or error
      }
    };

    fetchUserRoles();
  }, [account, apiUrl]);

  const USER_ROLE_ID = user.is_admin;
  const logedRole = userRoles.find((o) => o.value === USER_ROLE_ID)?.label;
  const role = logedRole && logedRole.toLowerCase();
  //   const isHR = logedRole && logedRole.toLowerCase().includes("hr");
  //   const isAcc = logedRole && logedRole.toLowerCase().includes("accountant");
  //   const isManager = logedRole && logedRole.toLowerCase().includes("manager");
  //   const isSupervisor =
  //     logedRole && logedRole.toLowerCase().includes("supervisor");
  //   const isAdmin = logedRole && logedRole.toLowerCase().includes("admin");

  const userRole = role;
  const isAdmin = userRole === "admin";
  const isManager = ["admin", "manager"].includes(userRole);
  const isAccountant = ["admin", "accountant"].includes(userRole);
  const isHR = ["admin", "hr"].includes(userRole);
useEffect(() => {
    fetchDashboardData();
    const interval = setInterval(fetchDashboardData, 60000);
    return () => clearInterval(interval);
  }, [dateRange, selectedFarm]);

  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      const params = {
        farm: selectedFarm,
        startDate: dateRange[0]?.format("YYYY-MM-DD"),
        endDate: dateRange[1]?.format("YYYY-MM-DD"),
        role: role,
      };

      const [
        statsRes,
        assetsRes,
        salesRes,
        consumptionsRes,
        inventoryRes,
        hrRes,
        accountingRes,
        chartsRes,
        activitiesRes,
      ] = await Promise.all([
        api.get(`/dashboard/stats`, { params }),
        api.get(`/dashboard/assets`, { params }),
        api.get(`/dashboard/sales`, { params }),
        api.get(`/dashboard/consumptions`, { params }),
        api.get(`/dashboard/inventory`, { params }),
        isHR
          ? api.get(`/dashboard/hr`, { params })
          : Promise.resolve({ data: {} }),
        isAccountant
          ? api.get(`/dashboard/accounting`, { params })
          : Promise.resolve({ data: {} }),
        api.get(`/dashboard/charts`, { params }),
        api.get(`/dashboard/recent-activities`),
      ]);
setStats(statsRes.data);
      setAssetsData(assetsRes.data);
      setSalesData(salesRes.data);
      setConsumptionsData(consumptionsRes.data);
      setInventoryData(inventoryRes.data);
      if (isHR) setHrData(hrRes.data);
      if (isAccountant) setAccountingData(accountingRes.data);
      setChartData(chartsRes.data);
      setRecentActivities(activitiesRes.data);
    } catch (err) {
      console.error("Failed to fetch dashboard data", err);
      message.error("Failed to load dashboard data");
    } finally {
      setLoading(false);
    }
  };

  const assetColumns = [
    {
      title: "Tag/Batch",
      dataIndex: "tagNumber",
      key: "tagNumber",
      render: (v, r) => v || r.batchId || r.assetName,
    },
    { title: "Type", dataIndex: "type_name", key: "type_name" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (v) => (
        <Tag color={v === "alive" ? "green" : v === "sold" ? "blue" : "orange"}>
          {v}
        </Tag>
      ),
    },
    {
      title: "Current Value",
      dataIndex: "currentValue",
      key: "currentValue",
      render: (v) => `${formatKES(v)}`,
    },
    { title: "Farm", dataIndex: "farm", key: "farm" },
    {
      title: "Recorded",
      dataIndex: "recorded",
      key: "recorded",
      render: (v) => dayjs(v).format("YYYY-MM-DD"),
    },
  ];

  const salesColumns = [
    {
      title: "Transaction ID",
      dataIndex: "transactionId",
      key: "transactionId",
    },
    { title: "Customer", dataIndex: "customer_name", key: "customer_name" },
    {
      title: "Total",
      dataIndex: "totalCost",
      key: "totalCost",
      render: (v) => `${formatKES(v)}`,
    },
    {
      title: "Paid",
      dataIndex: "paidAmount",
      key: "paidAmount",
      render: (v) => `${formatKES(v)}`,
    },
    {
      title: "Status",
      dataIndex: "paymentStatus",
      key: "paymentStatus",
      render: (v) => (
        <Tag
          color={
            v === "fully_paid"
              ? "green"
              : v === "partially_paid"
              ? "orange"
              : "red"
          }
        >
          {v}
        </Tag>
      ),
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (v) => dayjs(v).format("YYYY-MM-DD"),
    },
  ];

  const consumptionColumns = [
    { title: "Item", dataIndex: "item_name", key: "item_name" },
    { title: "Type", dataIndex: "item_type", key: "item_type" },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (v, r) => `${v} ${r.unit}`,
    },
    { title: "Reason", dataIndex: "reason", key: "reason" },
    {
      title: "Date",
      dataIndex: "consumption_date",
      key: "consumption_date",
      render: (v) => dayjs(v).format("YYYY-MM-DD"),
    },
    {
      title: "Recorded By",
      dataIndex: "firstname",
      key: "firstname",
      render: (v, r) => `${r.firstname || ""} ${r.lastname || ""}`,
    },
  ];

  const formattedSalesTrend = (chartData.salesTrend || []).map((item) => ({
    ...item,
    date: new Date(item.date).toISOString().split("T")[0], // YYYY-MM-DD
  }));

  const formattedconsumptionTrend = (chartData.consumptionTrend || []).map(
    (item) => ({
      ...item,
      date: new Date(item.date).toISOString().split("T")[0], // YYYY-MM-DD
    }),
  );

  // Chart configurations
  const salesTrendConfig = {
    data: formattedSalesTrend || [],
    xField: "date",
    yField: "amount",
    point: { size: 5, shape: "diamond" },
    smooth: true,
    color: "#1890ff",
    areaStyle: { fillOpacity: 0.3 },
  };

  const consumptionTrendConfig = {
    data: formattedconsumptionTrend || [],
    xField: "date",
    yField: "quantity",
    point: { size: 5 },
    smooth: true,
    color: "#ff9800",
    areaStyle: { fillOpacity: 0.3 },
  };

  const assetsPieConfig = {
    data: (chartData.assetsByType || []).map((item) => ({
      type: item.type_slug,
      value: item.count,
    })),
    angleField: "value",
    colorField: "type",
    label: { content: "{name}", style: { fontSize: 12 } },
  };

  // 👇 Wait until roles are loaded
  if (loading) {
    return <div>Loading...</div>; // or a spinner
  }

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "400px",
        }}
      >
        <Spin size="large" tip="Loading dashboard..." />
      </div>
    );
  }

  return (
    <div>
      <Tabs activeKey={activeTabs} onChange={setActiveTabs}>
        <TabPane tab="Animal & Assets" key="assests">
          <AnimalAssetsDashboard farms={farms} />
        </TabPane>
        <TabPane tab="Analytics" key="analytics">
          {/* Filter Bar */}
          <Card style={{ marginBottom: 16 }}>
            <Space size="middle" wrap>
              <span>
                <FilterOutlined /> Filters:
              </span>
              <Select
                value={selectedFarm}
                onChange={setSelectedFarm}
                style={{ width: 200 }}
              >
                <Option value="all">All Farms</Option>

                {farms.map((farm) => (
                  <Option key={farm.id} value={farm.name}>
                    {farm.name}
                  </Option>
                ))}
              </Select>
              <RangePicker value={dateRange} onChange={setDateRange} />
              <Button
                type="primary"
                icon={<ReloadOutlined />}
                onClick={fetchDashboardData}
              >
                Refresh
              </Button>
              <Button icon={<DownloadOutlined />}>Export Report</Button>
            </Space>
          </Card>

          {/* Stats Cards */}
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} lg={6}>
              <Card>
                <Statistic
                  title="Total Assets Value"
                  value={stats.assetsValue?.value || 0}
                  precision={2}
                  prefix={<MoneyCollectOutlined/>}
                  valueStyle={{ color: "#3f8600" }}
                  suffix={<RiseOutlined />}
                />
                <div>
                  <span>
                    {stats.totalLivestock?.count || 0} Livestock |{" "}
                    {stats.totalPhysicalAssets?.count || 0} Physical
                  </span>
                </div>
              </Card>
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <Card>
                <Statistic
                  title="Monthly Sales"
                  value={stats.monthSales?.amount || 0}
                  precision={2}
                  prefix={<MoneyCollectOutlined/>}
                  valueStyle={{ color: "#1890ff" }}
                />
                <div>Today: {formatKES(stats.todaySales?.amount) || 0}</div>
              </Card>
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <Card>
                <Statistic
                  title="Monthly Consumption"
                  value={stats.monthConsumption?.total || 0}
                  suffix="units"
                  valueStyle={{ color: "#faad14" }}
                />
                <div>Today: {stats.todayConsumption?.total || 0} units</div>
              </Card>
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <Card>
                <Statistic
                  title="Stakeholders"
                  value={stats.totalStakeholders?.count || 0}
                  // suffix="trays"
                  valueStyle={{ color: "#722ed1" }}
                />
                <div>
                  {stats.totalCustomers?.count || 0} Customers | {stats.totalSuppliers?.count || 0} Suppliers | {stats.totalVeterinarians?.count || 0} Veterinarians
                </div>
              </Card>
            </Col>
          </Row>

          {/* Second Row - Additional Stats for Admin/Manager */}
          {(isAdmin || isManager || isAccountant) && (
            <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
              <Col xs={24} sm={12} lg={6}>
                <Card>
                  <Statistic
                    title="Inventory Value"
                    value={inventoryData.summary?.totalValue || 0}
                    precision={2}
                    prefix={<MoneyCollectOutlined/>}
                  />
                  <div>
                    {inventoryData.summary?.totalItems || 0} items in stock
                  </div>
                </Card>
              </Col>
              <Col xs={24} sm={12} lg={6}>
                <Card>
                  <Statistic
                    title="Employees"
                    value={stats.totalEmployees?.count || 0}
                    prefix={<TeamOutlined />}
                  />
                  <div>{stats.presentToday?.count || 0} present today</div>
                </Card>
              </Col>
              <Col xs={24} sm={12} lg={6}>
                <Card>
                  <Statistic
                    title="Total Payments"
                    value={stats.totalPayments?.total || 0}
                    precision={2}
                    prefix={<MoneyCollectOutlined/>}
                    valueStyle={{ color: "#cf1322" }}
                  />
                  <div>
                    <Tag color="green">
                      Receivables:{" "}
                      {formatKES(stats?.receivables?.total_receivables) || 0}
                    </Tag>
                    <Tag color="red">
                      Payables:{" "}
                      {formatKES(stats?.payables?.total_payables) || 0}
                    </Tag>
                  </div>
                  {/* <div>{stats.overduePayments?.total > 0 && <Tag color="red">Overdue: ${stats.overduePayments?.total}</Tag>}</div> */}
                </Card>
              </Col>
              <Col xs={24} sm={12} lg={6}>
                <Card>
                  <Statistic
                    title="Low Stock Alerts"
                    value={inventoryData.summary?.lowStockCount || 0}
                    valueStyle={{ color: "#faad14" }}
                    prefix={<WarningOutlined />}
                  />
                  <Button type="link" size="small">
                    View details
                  </Button>
                </Card>
              </Col>
            </Row>
          )}

          {/* Tabs for Detailed Data */}
          <Card style={{ marginTop: 16 }} size="small">
            <Tabs activeKey={activeTab} onChange={setActiveTab}>
              <TabPane tab="Charts & Trends" key="charts">
                <Row gutter={[16, 16]}>
                  <Col xs={24} lg={12}>
                    <Card title="Sales Trend (Last 30 Days)" size="small">
                      <Line {...salesTrendConfig} height={300} />
                    </Card>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Card title="Consumption Trend (Last 30 Days)" size="small">
                      <Line {...consumptionTrendConfig} height={300} />
                    </Card>
                  </Col>
                  <Col xs={24} lg={8}>
                    <Card title="Assets Distribution" size="small">
                      <Pie {...assetsPieConfig} height={300} />
                    </Card>
                  </Col>
                  <Col xs={24} lg={8}>
                    <Card title="Sales by Payment Method" size="small">
                      <Bar
                        data={chartData.salesByMethod || []}
                        xField="paymentMethod"
                        yField="total"
                        height={300}
                      />
                    </Card>
                  </Col>
                  <Col xs={24} lg={8}>
                    <Card title="Payments by Payment Method" size="small">
                      <Bar
                        data={chartData.paymentByMethod || []}
                        xField="paymentMethod"
                        yField="total"
                        height={300}
                      />
                    </Card>
                  </Col>
                </Row>
              </TabPane>

              <TabPane tab="Assets" key="assets">
                <Table
                  size="small"
                  dataSource={assetsData.data}
                  columns={assetColumns}
                  rowKey="id"
                  pagination={{ pageSize: 10 }}
                  scroll={{ x: 800 }}
                  summary={(pageData) => {
                    let totalValue = 0;
                    pageData.forEach(({ currentValue }) => {
                      totalValue += parseFloat(currentValue || 0);
                    });
                    return (
                      <Table.Summary>
                        <Table.Summary.Row>
                          <Table.Summary.Cell index={0} colSpan={3}>
                            Total Value
                          </Table.Summary.Cell>
                          <Table.Summary.Cell index={3}>
                            {formatKES(totalValue)}
                          </Table.Summary.Cell>
                          <Table.Summary.Cell
                            index={4}
                            colSpan={2}
                          ></Table.Summary.Cell>
                        </Table.Summary.Row>
                      </Table.Summary>
                    );
                  }}
                />
              </TabPane>

              <TabPane tab="Sales" key="sales">
                <Table
                  size="small"
                  dataSource={salesData.sales}
                  columns={salesColumns}
                  rowKey="id"
                  pagination={{ pageSize: 10 }}
                  scroll={{ x: 800 }}
                />
              </TabPane>

              <TabPane tab="Consumptions" key="consumptions">
                <Table
                  size="small"
                  dataSource={consumptionsData.data}
                  columns={consumptionColumns}
                  rowKey="id"
                  pagination={{ pageSize: 10 }}
                  scroll={{ x: 800 }}
                />
              </TabPane>

              {(isAdmin || isManager) && (
                <TabPane tab="Inventory" key="inventory">
                  <Descriptions
                    title="Inventory Summary"
                    bordered
                    size="small"
                    column={4}
                  >
                    <Descriptions.Item label="Total Headers">
                      {inventoryData.summary?.totalHeaders || 0}
                    </Descriptions.Item>
                    <Descriptions.Item label="Total Value">
                      {formatKES(inventoryData.summary?.totalValue) || 0}
                    </Descriptions.Item>
                    <Descriptions.Item label="Total Items">
                      {inventoryData.summary?.totalItems || 0}
                    </Descriptions.Item>
                    <Descriptions.Item label="Low Stock Items">
                      {inventoryData.summary?.lowStockCount || 0}
                    </Descriptions.Item>
                  </Descriptions>
                  <Table
                    dataSource={inventoryData.items}
                    columns={[
                      { title: "Item Name", dataIndex: "name" },
                      { title: "Category", dataIndex: "category" },
                      { title: "Type", dataIndex: "type" },
                      { title: "Unit", dataIndex: "unit" },
                      { title: "Current Stock", dataIndex: "current_stock" },
                      { title: "Initial Stock", dataIndex: "initial_stock" },
                      {
                        title: "Status",
                        render: (_, r) => (
                          <Tag
                            color={r.current_stock <= 10 ? "orange" : "green"}
                          >
                            {r.current_stock <= 10 ? "Low Stock" : "In Stock"}
                          </Tag>
                        ),
                      },
                    ]}
                    rowKey="id"
                    pagination={{ pageSize: 5 }}
                  />
                </TabPane>
              )}

              {isHR && (
                <TabPane tab="HR & Payroll" key="hr">
                  <Descriptions
                    title="HR Summary"
                    bordered
                    size="small"
                    column={3}
                  >
                    <Descriptions.Item label="Total Employees">
                      {hrData.summary?.totalEmployees || 0}
                    </Descriptions.Item>
                    <Descriptions.Item label="Active">
                      {hrData.summary?.activeEmployees || 0}
                    </Descriptions.Item>
                    <Descriptions.Item label="Monthly Payroll">
                      {formatKES(hrData.payroll?.total_payroll) || 0}
                    </Descriptions.Item>
                  </Descriptions>
                  <Table
                    size="small"
                    dataSource={hrData.employees}
                    columns={[
                      {
                        title: "Name",
                        render: (_, r) => `${r.firstname} ${r.lastname}`,
                      },
                      { title: "Position", dataIndex: "position_name" },
                      { title: "Department", dataIndex: "department" },
                      {
                        title: "Base Salary",
                        dataIndex: "base_salary",
                        render: (v) => `${formatKES(v)}`,
                      },
                      {
                        title: "Status",
                        dataIndex: "is_active",
                        render: (v) => (
                          <Tag color={v === "Active" ? "green" : "red"}>
                            {v}
                          </Tag>
                        ),
                      },
                    ]}
                    rowKey="id"
                    pagination={{ pageSize: 5 }}
                  />
                </TabPane>
              )}

              {isAccountant && (
                <TabPane tab="Accounting" key="accounting">
                  <Descriptions
                    title="Accounting Summary"
                    bordered
                    size="small"
                    column={3}
                  >
                    <Descriptions.Item label="Transactions">
                      {accountingData.summary?.totalTransactions || 0}
                    </Descriptions.Item>
                    <Descriptions.Item label="Total Debit">
                      {formatKES(accountingData.summary?.totalDebit) || 0}
                    </Descriptions.Item>
                    <Descriptions.Item label="Total Credit">
                      {formatKES(accountingData.summary?.totalCredit) || 0}
                    </Descriptions.Item>
                  </Descriptions>
                  <Table
                    size="small"
                    dataSource={accountingData.transactions}
                    columns={[
                      {
                        title: "Transaction Code",
                        dataIndex: "transaction_code",
                      },
                      {
                        title: "Date",
                        dataIndex: "transaction_date",
                        render: (v) => dayjs(v).format("YYYY-MM-DD"),
                      },
                      {
                        title: "Amount",
                        dataIndex: "amount",
                        render: (v) => `${formatKES(v)}`,
                      },
                      { title: "GL Debit", dataIndex: "gl_debit" },
                      { title: "GL Credit", dataIndex: "gl_credit" },
                      { title: "Description", dataIndex: "description" },
                    ]}
                    rowKey="id"
                    pagination={{ pageSize: 5 }}
                  />
                </TabPane>
              )}
            </Tabs>
          </Card>

          {/* Recent Activities */}
          <Card
            title="Recent Activities"
            style={{ marginTop: 16 }}
            size="small"
          >
            <List
              dataSource={recentActivities}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    avatar={
                      <Avatar
                        icon={
                          item.type === "sale" ? (
                            <ShoppingOutlined />
                          ) : item.type === "consumption" ? (
                            <FileAddFilled />
                          ) : item.type === "asset" ? (
                            <CarOutlined />
                          ) : (
                            <DatabaseOutlined />
                          )
                        }
                      />
                    }
                    title={
                      <Space>
                        {item.description}
                        <Tag
                          color={
                            item.type === "sale"
                              ? "green"
                              : item.type === "consumption"
                              ? "orange"
                              : "blue"
                          }
                        >
                          {item.type}
                        </Tag>
                      </Space>
                    }
                    description={`By ${item.user_name || "System"} on ${dayjs(
                      item.date,
                    ).format("YYYY-MM-DD HH:mm")}`}
                  />
                </List.Item>
              )}
              pagination={{ pageSize: 10 }}
            />
          </Card>
        </TabPane>
      </Tabs>
    </div>
  );
}

export default Dashboard;
